import {FuncTestingPageTitle} from '@/src/features/functional-testing/ui/page-title'


export {FuncTestingPageTitle}
